import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconReplaceImage';
/** Renders an SVG icon. */
const SvgReplaceImage = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M16 17a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1zm2 8a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3z"
      />
      <path
        fill="currentColor"
        d="M15.167 25.553a1 1 0 1 0 1.666-1.106l-3.095-4.667a1 1 0 0 0-1.628-.054L9.85 22.68l-1.115-.82a1 1 0 0 0-1.329.13l-2.142 2.332a1 1 0 0 0 1.472 1.354l1.536-1.673 1.183.868.085.056a1 1 0 0 0 1.302-.253l2.005-2.62 2.32 3.498ZM26 15V7a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3a1 1 0 1 1-2 0V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-3a1 1 0 1 1 0-2h3a1 1 0 0 0 1-1m-2 9v-.586l-.793.793a1 1 0 1 1-1.414-1.414l2.5-2.5.076-.068a1 1 0 0 1 1.338.068l2.5 2.5a1 1 0 1 1-1.414 1.414L26 23.414V24a4 4 0 0 1-4 4h-1a1 1 0 1 1 0-2h1a2 2 0 0 0 2-2M8 8v.586l.793-.793a1 1 0 1 1 1.414 1.414l-2.5 2.5-.076.068a1 1 0 0 1-1.338-.068l-2.5-2.5a1 1 0 1 1 1.414-1.414L6 8.586V8a4 4 0 0 1 4-4h1a1 1 0 1 1 0 2h-1a2 2 0 0 0-2 2"
      />
    </svg>
  );
};
SvgReplaceImage.displayName = displayName;
export default SvgReplaceImage;
